/*
 _	   __	  _ __
| |	 / /___ _(_) /____
| | /| / / __ `/ / / ___/
| |/ |/ / /_/ / / (__  )
|__/|__/\__,_/_/_/____/
The electron alternative for Go
(c) Lea Anthony 2019-present
*/
import { newRuntimeCaller, objectNames } from "./runtime.js";
// setup
window._wails = window._wails || {};
const call = newRuntimeCaller(objectNames.Dialog);
// Define constants from the `methods` object in Title Case
const DialogInfo = 0;
const DialogWarning = 1;
const DialogError = 2;
const DialogQuestion = 3;
const DialogOpenFile = 4;
const DialogSaveFile = 5;
/**
 * Presents a dialog of specified type with the given options.
 *
 * @param type - Dialog type.
 * @param options - Options for the dialog.
 * @returns A promise that resolves with result of dialog.
 */
function dialog(type, options = {}) {
    return call(type, options);
}
/**
 * Presents an info dialog.
 *
 * @param options - Dialog options
 * @returns A promise that resolves with the label of the chosen button.
 */
export function Info(options) { return dialog(DialogInfo, options); }
/**
 * Presents a warning dialog.
 *
 * @param options - Dialog options.
 * @returns A promise that resolves with the label of the chosen button.
 */
export function Warning(options) { return dialog(DialogWarning, options); }
/**
 * Presents an error dialog.
 *
 * @param options - Dialog options.
 * @returns A promise that resolves with the label of the chosen button.
 */
export function Error(options) { return dialog(DialogError, options); }
/**
 * Presents a question dialog.
 *
 * @param options - Dialog options.
 * @returns A promise that resolves with the label of the chosen button.
 */
export function Question(options) { return dialog(DialogQuestion, options); }
export function OpenFile(options) { var _a; return (_a = dialog(DialogOpenFile, options)) !== null && _a !== void 0 ? _a : []; }
/**
 * Presents a file selection dialog to pick a file to save.
 *
 * @param options - Dialog options.
 * @returns Selected file, or a blank string if no file has been selected.
 */
export function SaveFile(options) { return dialog(DialogSaveFile, options); }
